module.exports = __webpack_public_path__ + "img/score2.9f8354eb.jpg";